<template>
  <div class='header-box'>
    <img v-if='platformLogo &&!service' :src='platformLogo' class='logo'>
    <span class='title'>{{ platformLogo && !service ? '| ' : '' }}{{ service ? serviceName : defaultTitle }}</span>
    <div class='user-box'>
      <span v-if='service' style='color: white;font-size: 16px'>{{ authorizedUserName() }}</span>
      <user-menu v-else></user-menu>
    </div>
    <a-popover
      v-if='!service && serviceList && serviceList.length>0'
      title='站内消息通知'
      style='float: right;margin-right: 20px' placement="bottomRight">
      <template slot='content'>
        <a-table
          :dataSource='serviceList'
          :columns='getServiceColumns()'
          :showHeader='false'
          :pagination='false'
          :row-key='record => record.name'
        >
          <template slot='name' slot-scope='text,record'>
            <span>{{ text }}：剩余<a style='color: red'>{{ record.days }}</a>天到期</span>
          </template>
        </a-table>
      </template>
      <span>
       <span style='color: #fff;'>{{ serviceList[0].name }}</span>
       <span style='color: red;margin-left: 10px' @click.t.stop='showServiceEvent'>到期提醒</span>
      </span>
    </a-popover>
  </div>
</template>

<script>
import UserMenu from '../../components/tools/UserMenu'
import { mapGetters } from 'vuex'

export default {
  name: 'PageHeader',
  components: { UserMenu },

  props: {
    service: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    serviceList() {
      return this.$store.getters.systemService
    }
  },
  data() {
    return {
      platformLogo: '',
      serviceName: '',
      defaultTitle: ''
    }
  },
  mounted() {
    let platformId = this.getPlatformConfig().platformId
    this.serviceName = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
    this.defaultTitle = platformId === 8 ? '鲲鹏中台系统' : '商家工作台' // platformId 为8才需要替换(鲲鹏云)
    this.serviceName = platformId === 8 ? '鲲鹏中台系统' : this.serviceName // platformId 为8才需要替换(鲲鹏云)
    this.platformLogo = this.getPlatformConfig().platformLogo
  },
  methods: {
    ...mapGetters(['authorizedUserName']),
    getServiceColumns() {
      return [
        {
          title: '站内消息通知',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        }
      ]
    }
  }

}
</script>
<style scoped>
.header-box {
  //background-color: #001529;
  background-color: #002140;
  height: 60px;
  width: 100%;
  line-height: 60px;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 30px;
}

.logo {
  float: left;
  margin-top: 10px;
  height: 40px;
  width: 165px;
}

.title {
  float: left;
  margin-left: 6px;
  color: white;
  font-weight: 500;
  font-size: 20px;
}

.user-box {
  height: 60px;
  line-height: 60px;
  float: right;
}
</style>
